import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import { Button, Dialog, FormControl, IconButton, InputLabel, Typography } from "@material-ui/core";
import { BootstrapInput } from "../../pages/contact/contact.us";
import { SERVER_API_ORDERS } from "../../redux/api.constants";
import { OrderType } from "../../types/OrderType";
import CloseIcon from '@material-ui/icons/Close';

import s from './TrackOrderDialog.module.scss'

interface TrackOrderDialogProps {
    openManageOrdersPopup: boolean;
    onClose: () => void;
};

export const TrackOrderDialog = ({ openManageOrdersPopup, onClose }: TrackOrderDialogProps) => {
    const [userData, setUserData] = React.useState({
        customerNumber: '',
        po: '',
        zip: ''
    });

    const [errorCustomerNumber, setErrorCustomerNumber] = React.useState(false);
    const [errorPO, setErrorPO] = React.useState(false);
    const [errorZIP, setErrorZIP] = React.useState(false);

    const [responseError, setResponseError] = React.useState(false);

    const isNotValid = !userData.customerNumber || !userData.po || !userData.zip || errorCustomerNumber || errorPO || errorZIP;

    const handleChangeField = (field: 'customerNumber' | 'po' | 'zip') => (event: React.ChangeEvent<HTMLInputElement>) => {
        if (responseError) {
            setResponseError(false)
        }

        setUserData({
            ...userData,
            [field]: event.target.value
        });

        if (field === 'customerNumber') {
            setErrorCustomerNumber(event.target.value.length < 4);
        }
        if (field === 'po') {
            setErrorPO(event.target.value.length < 4);
        }
        if (field === 'zip') {
            setErrorZIP(event.target.value.length < 4);
        }
    };

    const handleCloseDialog = () => {
        
        setResponseError(false)
        onClose();
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const { customerNumber, po, zip } = userData;

        if (isNotValid) return;

        try {
            const response = await axios.post(`${SERVER_API_ORDERS}/check-order`, {
                customerNumber,
                po,
                zip,
            });

            if (response.data?.success && response.data?.order[0].slug) {
                window.location.href = `/orderTracking/${response.data?.order[0]._id}`;
            }

            handleCloseDialog();
        } catch (error) {
            setResponseError(true);
            console.error('Error during submission:', error);
        }
    };

    return (
        <>
            <Dialog open={openManageOrdersPopup} onClose={handleCloseDialog}>
                <form className={s.form} onSubmit={handleSubmit}>
                    <Typography className={s.title}>Track Your Order</Typography >
                    <IconButton className={s.iconClose} onClick={handleCloseDialog}>
                        <CloseIcon />
                    </IconButton>

                    <div className={s.inputs_wrapper}>
                        <FormControl className={s.field_container}>
                            <InputLabel shrink htmlFor="customer-number" className={s.label}>
                                Raynor Customer Number<span className={s.red}>*</span>
                            </InputLabel>
                            <BootstrapInput
                                className={errorCustomerNumber ? s.field_error : s.field}
                                required
                                id="customer-number"
                                value={userData.customerNumber}
                                placeholder={'Raynor Customer Number'}
                                onChange={handleChangeField('customerNumber')}
                            />
                        </FormControl>

                        <FormControl className={s.field_container}>
                            <InputLabel shrink htmlFor="po-number" className={s.label}>
                                Raynor Sales Order Number or Customer PO Number<span className={s.red}>*</span>
                            </InputLabel>
                            <BootstrapInput
                                className={errorPO ? s.field_error : s.field}
                                required
                                id="po-number"
                                value={userData.po}
                                placeholder={'Raynor Sales Order Number or Customer PO Number'}
                                onChange={handleChangeField('po')}
                            />
                        </FormControl>

                        <FormControl className={s.field_container}>
                            <InputLabel shrink htmlFor="zip-code" className={s.label}>
                                Your Ship-to ZIP code<span className={s.red}>*</span>
                            </InputLabel>
                            <BootstrapInput
                                className={errorZIP ? s.field_error : s.field}
                                required
                                id="zip-code"
                                value={userData.zip}
                                placeholder={'Shipping Zip Code'}
                                onChange={handleChangeField('zip')}
                            />
                        </FormControl>

                        {responseError && <div className={s.resError}>
                            Using the information you’ve provided, our Order Status system has not found
                            tracking information for your order. Please verify the information you’ve entered or contact
                            us at <a href="mailto:customerservice@raynorgroup.com">customerservice@raynorgroup.com</a></div>}

                        <Button
                            disabled={isNotValid}
                            style={{ backgroundColor: isNotValid ? 'gray' : 'black', color: 'white', padding: "20.5px" }}
                            fullWidth
                            type="submit">Confirm</Button>

                        <span className={s.link}>By entering your email, you agree to Eurotech's <a className={s.redLink} href="/privacy-policy">terms of service</a> and <a className={s.redLink} href="/privacy-policy" >privacy policy.</a></span>
                    </div>
                </form>
            </Dialog>
        </>
    );
};
